import { render, staticRenderFns } from "./JobRequestList.vue?vue&type=template&id=52521a4d&"
import script from "./JobRequestList.vue?vue&type=script&lang=js&"
export * from "./JobRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports